export const bootstrapLarguraSM = 576;
export const bootstrapLarguraXL = 1200;
